<template>
  <b-modal id="modalShow" no-close-on-esc hide-footer centered size="lg" headerClass="p-3" header-close-variant="dark" title="تنظیمات پیگیری">
    <div class="">
      <div class="mb-4">
        <div class="row">
          <div class="col-2">
            <div class="mainSMdiv">
              <div>روز</div>
            </div>
          </div>
          <div class="col-10">
            <div>متن پیام</div>
          </div>
        </div>
        <div class="row my-2" v-for="(note, index) in notes" :key="index + 1">
          <div class="col-2">
            <div class="mainSMdiv">
              <Spinner @input="note.day = $event" :value="note.day" />
            </div>
          </div>
          <div class="col-10">
            <div class="mainSMdiv d-flex align-items-center">
              <TextArea :showTitle="false" rows="2" textAreaClass="align-items-center" :value="note.text" @input="note.text = $event" @focused="addNewNote(index)" />
              <i v-if="notes.length > 1" @click.self="removeNote(index)" class="fa-thin fa-circle-xmark fa-2x ms-2"></i>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="btnDiv d-flex flex-row-reverse mt-3">
              <Button @click.native="fireNotif" btnClass="approve ms-2" text="ارسال" />
              <Button @click.native="submit" btnClass="sendBtn" text="ثبت" />
              <Button @click.native="$bvModal.hide('modalShow')" btnClass="cancel btn-outline" text="انصراف" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Spinner from '../../common/form/formModules/SpinnerInput.vue'
import TextArea from '../../common/form/formModules/TextAreaInput.vue'
import Button from '../../common/Button.vue'
import notificationsDataProvider from '../../../services/notifications'

export default {
  components: {
    Spinner,
    TextArea,
    Button,
  },
  props: {
    showSetting: {
      type: Boolean,
      default: false,
    },
    earlyData: {
      type: Array,
    },
  },
  data() {
    return {
      notes: [
        {
          text: '',
          day: 0,
        },
      ],
    }
  },
  methods: {
    removeNote(payload) {
      this.notes.splice(payload, 1)
    },
    addNewNote(payload) {
      let temp = {
        text: '',
        day: 0,
      }
      if (payload === this.notes.length - 1) {
        this.notes.push(temp)
      }
    },
    submit() {
      notificationsDataProvider
        .sendNotif(this.notes)
        .then((res) => {
          this.$bvModal.hide('modalShow')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    fireNotif() {
      notificationsDataProvider
        .fireNotif()
        .then((res) => {
          this.$bvModal.hide('modalShow')
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  watch: {},
  mounted() {
    if (this.earlyData && this.earlyData.length > 0) {
      this.notes = this.earlyData
    }
    this.$bvModal.show('modalShow')
  },
  beforeDestroy() {
    this.$bvModal.hide('modalShow')
  },
}
</script>

<style scoped lang="sass">
@import 'setting'
</style>
